import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { formatDateLL } from "../../../algorithms";
import { customStyle } from "../../../algorithms/styleDirection";
import { paths } from "../../../paths/paths";
import ModalComponent from "../../reusableComponents/modal";
import Icon from "../../sharedComponents/icons/fontawsomeIcons";
import DeleteProcAlert from "../../tasks/editProc.js/deleteProc";
import { resolver } from "../../../API/middlewares/resolveRequests";
import EditDiscussionForm from "./postEditForm";
import { EditPostData } from "../../../API/store/actions/auth";
import NotAllowedModal from "../../reusableComponents/notAllowedModal";
import { useSelector } from "react-redux";

const PostCard = ({
  userToken,
  item,
  procAdded,
  setProcAdded,
  fromCommunity = false,
  show,
  setshow,
}) => {
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [data, setData] = useState(null);
  const [VisibleEditProc, setVisibleEditProc] = useState(false);
  const userLogged = useSelector((state) => state.login.userData);
  const [showNotAllowedModal, setShowNotAllowedModal] = useState(false);
  const onShowNotAllowedModal = () => {
    setShowNotAllowedModal(true);
  };

  const renderNotAllowedModal = () => {
    return (
      <NotAllowedModal
        show={showNotAllowedModal}
        onHide={() => setShowNotAllowedModal(false)}
      />
    );
  };

  useEffect(() => {
    if (data) {
      if (data?.status <= 206) setVisibleEditProc(true);
      else onShowNotAllowedModal();
    }
  }, [data]);

  window.onclick = function (event) {
    if (
      !event.target.matches(".icon") &&
      !event.target.matches(".icon svg path")
    ) {
      var sharedowns = document.getElementsByClassName(
        `${customStyle("dropdown-menu-discussion")}`
      );
      for (let i = 0; i < sharedowns?.length; i++) {
        var openSharedown = sharedowns[i];
        if (openSharedown?.classList?.contains("show")) {
          openSharedown?.classList?.remove("show");
          setshow({ id: null, display: false });
        }
      }
    }
  };

  return (
    <>
      <ModalComponent
        body={
          <DeleteProcAlert
            userToken={userToken}
            setProcAdded={setProcAdded}
            procAdded={procAdded}
            postId={item?.id}
            internal={false}
            setVisible={setDeleteModalVisible}
            content={"هل تريد حذف المنشور والتعليقات التابعة له؟"}
          />
        }
        hasImage={
          <img
            src="/assets/images/deleteicon.png"
            width={20}
            height={20}
            alt=""
          />
        }
        size={"s"}
        modalVisible={deleteModalVisible}
        setModalVisible={setDeleteModalVisible}
        title={"هل انت متاكد"}
        background={"modalBackground mx-5"}
      />
      <ModalComponent
        body={
          <EditDiscussionForm
            userToken={userToken}
            setVisible={setVisibleEditProc}
            forumData={data}
            setProcAdded={setProcAdded}
            procAdded={procAdded}
          />
        }
        hasImage={
          <img
            src="/assets/images/greeniconedit.svg"
            width={20}
            height={20}
            alt=""
          />
        }
        setModalVisible={setVisibleEditProc}
        modalVisible={VisibleEditProc}
        size={"xl"}
        title={"تعديل المنشور"}
      />
      <div
        className="w-100 my-3"
        style={{
          border: "solid 1px #DFDFE2",
          borderRadius: 10,
          cursor: "pointer",
          zIndex: 0,
        }}
      >
        <div className="d-flex justify-content-between px-2">
          <Link
            to={`/post/${item.id}`}
            style={{ textDecoration: "none" }}
            className="col"
          >
            <div className="px-4 py-2" id={item.id}>
              <div style={{ color: "#000000", fontWeight: "bold" }}>
                {item.title}
              </div>
              <div className="text-muted my-2" style={{ fontSize: 13 }}>
                {formatDateLL(item.createDate)}
              </div>
              <div style={{ color: "#444444" }}>{item.description}</div>
              <div
                className=" d-flex align-items-center my-3"
                style={{ color: "#000000" }}
              >
                <div className="mx-2">
                  <img
                    src={`${paths.Members}${item.senderId}/${item.senderPhoto}`}
                    style={{ width: 30, height: 30, borderRadius: 10 }}
                    alt={""}
                  />
                </div>
                <div className="mx-2">{item.senderName}</div>
              </div>
            </div>
          </Link>
          <div>
            {!fromCommunity && (
              <div className="col d-flex justify-content-end align-items-end btn-group">
                {show?.id == item?.id ? (
                  <>
                    <div
                      style={{ display: show.display ? "block" : "none" }}
                      className={`${customStyle("arrow-horizontal-discussion")}
                       ${show.display ? "show" : ""}
                      `}
                    ></div>
                    <ul
                      className={`${customStyle("dropdown-menu-discussion")} ${
                        show.display ? "show" : ""
                      }`}
                      style={{
                        display: show.display ? "block" : "none",
                      }}
                    >
                      {item.senderId == userLogged?.memberId ? (
                        <li
                          style={{ cursor: "pointer" }}
                          id={item.id}
                          onClick={() => {
                            resolver(EditPostData, setData, item.id, userToken);
                          }}
                        >
                          <span
                            className={`dropdown-item ${customStyle(
                              "dropdown-item"
                            )}`}
                          >
                            تعديل المنشور
                          </span>
                        </li>
                      ) : null}

                      {item.senderId == userLogged?.memberId ||
                      item.receiverId == userLogged?.memberId ? (
                        <li
                          style={{ cursor: "pointer" }}
                          id={item.id}
                          onClick={() => {
                            setDeleteModalVisible(true);
                          }}
                        >
                          <span
                            className={`dropdown-item ${customStyle(
                              "dropdown-item"
                            )}`}
                          >
                            حذف المنشور
                          </span>
                        </li>
                      ) : null}
                    </ul>
                  </>
                ) : null}

                {item.senderId == userLogged?.memberId ||
                item.receiverId == userLogged?.memberId ? (
                  <Icon
                    containerStyle={"mt-2 icon"}
                    id={item.id}
                    name="ellipsis-v"
                    size={18}
                    className=" d-flex icon"
                    style={{ display: "block" }}
                    onclick={(e) => {
                      const id = e.currentTarget.id;
                      id == null
                        ? setshow({
                            id,
                            display: true,
                          })
                        : id == show.id
                        ? setshow({
                            id: null,
                            display: false,
                          })
                        : setshow({
                            id,
                            display: true,
                          });
                    }}
                  />
                ) : null}
              </div>
            )}
          </div>
        </div>
      </div>
      {renderNotAllowedModal()}
    </>
  );
};

export default PostCard;
